import { CommunitySearchFeed } from '@/types'
import { View, CardBase, CardBaseProps, Image, Text } from '@/components'
import { arePropsEqual, TypeGuards } from '@codeleap/common'
import { variantProvider } from '@/app'
import React from 'react'

type CommunityCardProps = Partial<Omit<CardBaseProps, 'debugName'>> & {
  community: CommunitySearchFeed
}

export const CommunityCardComponent: React.FC<CommunityCardProps> = props => {
  const hasThumbnail = TypeGuards.isString(props?.community.image)

  return (
    <CardBase
      debugName={`CommunityCard-${props?.community?.id}`}
      variants={['card:feed']}
      style={styles.wrapper}
      gap={null}
      {...props}
    >
      {hasThumbnail ? <Image objectFit='cover' source={props?.community.image} style={styles.image} /> : null}
      <View
        variants={['gap:1', 'column', 'alignSelfCenter', 'padding: 2']}
        style={[hasThumbnail ? styles.imageTextWrapper : styles.textWrapper, { flex: 1 }]}
      >
        <Text variants={['h5', 'color:neutral7', 'ellipsis']} text={props?.community.title} />
        <Text variants={['p3', 'color:neutral5']} text={props?.community?.description} />
      </View>
    </CardBase>
  )
}

const styles = variantProvider.createComponentStyle(
  theme => ({
    wrapper: {
      boxShadow: '0px 2px 4px 0px rgba(153, 153, 153, 0.2)',
    },
    image: {
      width: '20%',
    },
    imageTextWrapper: {
      height: '100%',
      maxWidth: '80%',
    },
    textWrapper: {
      maxWidth: '100%',
      height: '100%',
    },
  }),
  true,
)

export const CommunityCard = React.memo(CommunityCardComponent, (previous, next) => {
  return arePropsEqual(previous, next, { check: ['community'] })
})
